import { render, staticRenderFns } from "./SlideShowList.vue?vue&type=template&id=f8b058ac&"
import script from "./SlideShowList.vue?vue&type=script&lang=js&"
export * from "./SlideShowList.vue?vue&type=script&lang=js&"
import style0 from "./SlideShowList.vue?vue&type=style&index=0&id=f8b058ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports